import { Route, Routes } from "react-router-dom";
import { CreateSupplier } from "./create";
import { EditSupplier } from "./edit";
import { SupplierTax } from "./list";

export default function SupplierTaxRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SupplierTax />} />
      <Route path="/criar-fornecedor" element={<CreateSupplier />} />
      <Route path="/editar-fornecedor/:id" element={<EditSupplier />} />
    </Routes>
  );
}
